import type { KnowledgeBase } from "@repo/app-types/entities/knowledgeBase";
import { EditableText } from "@repo/ui/Inputs/editableText";
import { showToast, ToastVariant } from "@repo/ui/toast/toast";
import type { FC } from "react";
import { useUpdateKnowledgeBaseMutation } from "../../../api/entities/knowledgeBase.js";

interface KnowledgeBaseNameEditorProps {
  knowledgeBase: Pick<KnowledgeBase, "id" | "name">;
}

export const KnowledgeBaseNameEditor: FC<KnowledgeBaseNameEditorProps> = (
  props,
) => {
  const { knowledgeBase } = props;
  const [updateKnowledgeBase] = useUpdateKnowledgeBaseMutation();

  const handleSave = async (name: string) => {
    try {
      await updateKnowledgeBase({
        id: knowledgeBase.id,
        data: { name },
      }).unwrap();

      showToast({
        title: "Knowledge base name updated successfully",
        variant: ToastVariant.Success,
      });
    } catch (err: any) {
      showToast({
        title: `Failed to update name: ${err.data?.error || err.message || "Unknown error"}`,
        variant: ToastVariant.Error,
      });
      throw err;
    }
  };

  return (
    <EditableText
      accessibleLabel="Knowledge base name"
      editAccessibleLabel="Edit knowledge base name"
      inputClassName="h-7 py-0 text-xl leading-7 font-semibold"
      isRequired
      maxLength={100}
      onSave={handleSave}
      value={knowledgeBase.name}
    />
  );
};
